/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ready_To_Convert_PagesInputs */

const en_mobile_ready_to_convert_pages = /** @type {(inputs: Mobile_Ready_To_Convert_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to upload and convert pages into audio?`)
};

const es_mobile_ready_to_convert_pages = /** @type {(inputs: Mobile_Ready_To_Convert_PagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para subir y convertir páginas en audio?`)
};

/**
* | output |
* | --- |
* | "Ready to upload and convert pages into audio?" |
*
* @param {Mobile_Ready_To_Convert_PagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ready_to_convert_pages = /** @type {((inputs?: Mobile_Ready_To_Convert_PagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ready_To_Convert_PagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ready_to_convert_pages(inputs)
	return en_mobile_ready_to_convert_pages(inputs)
});